import { useState, useEffect } from "react";
import { Sun, Moon, SunMoon } from "lucide-react";
import "./App.css";

// mode: 'auto' | 'light' | 'dark'
const MODES = ["auto", "light", "dark"];

function App() {
  const [mode, setMode] = useState(
    () => localStorage.getItem("sn-theme") || "auto"
  );
  const [sysDark, setSysDark] = useState(
    () => window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  // Track system preference for 'auto' mode
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => setSysDark(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  // Persist mode choice
  useEffect(() => {
    localStorage.setItem("sn-theme", mode);
  }, [mode]);

  const isDark =
    mode === "dark" || (mode === "auto" && sysDark);

  const cycleMode = () => {
    const next = MODES[(MODES.indexOf(mode) + 1) % MODES.length];
    setMode(next);
  };

  const ModeIcon = mode === "light" ? Sun : mode === "dark" ? Moon : SunMoon;
  const modeLabel = mode === "light" ? "Day" : mode === "dark" ? "Night" : "Auto";

  return (
    <div className={`page ${isDark ? "dark" : "light"}`} data-testid="landing-page">
      {/* Full-screen background watermark */}
      <img
        src="/hero-fadein-typewriter.png"
        className="hero-bg"
        alt=""
        aria-hidden="true"
      />

      {/* Graphite overlay for dark mode */}
      {isDark && <div className="dark-overlay" aria-hidden="true" />}

      {/* Theme toggle — top right */}
      <button
        className="theme-toggle"
        onClick={cycleMode}
        aria-label={`Switch theme, current: ${modeLabel}`}
        title={`Theme: ${modeLabel}`}
        data-testid="theme-toggle"
      >
        <ModeIcon size={15} strokeWidth={1.75} />
        <span className="theme-label">{modeLabel}</span>
      </button>

      {/* Centered content */}
      <main className="content" data-testid="main-content">
        {/* Logo */}
        <img
          src={isDark ? "/sn-logo-stacked-night.png" : "/sn-logo-stacked-day.png"}
          alt="Studio Notes"
          className="logo"
          data-testid="studio-notes-logo"
        />

        {/* Quote */}
        <p className="quote !font-serif !font-semibold !text-4xl !tracking-[.1em] !-mx-[100px]" data-testid="quote-text">
          &ldquo;Nobody knows anything.&rdquo;
        </p>

        {/* Attribution */}
        <p className="attribution" data-testid="attribution">
          WILLIAM GOLDMAN
        </p>

        {/* Heading */}
        <p className="heading" data-testid="heading">
          The Screenplay Development Room
        </p>

        {/* Tagline */}
        <p className="tagline !font-['Courier_New']" data-testid="tagline">
          Write anywhere. Develop here.
        </p>

        {/* Coming Soon — plain text, not a button */}
        <p className="coming-soon !font-semibold !text-lg" data-testid="coming-soon">
          COMING SOON
        </p>

        {/* Email — mailto link */}
        <a
          href="mailto:support@studionotesapp.com"
          className="email"
          data-testid="email"
        >
          support@studionotesapp.com
        </a>
      </main>
    </div>
  );
}

export default App;